<template>
    <div>
        <el-radio-group v-model="radioSelector" size="mini">>
            <el-radio-button label="EN"></el-radio-button>
            <el-radio-button :label="localKey"></el-radio-button>
        </el-radio-group>
        <el-input
                :size="size"
                v-model="locValue.EN"
                type="text"
                @input="updateInput()"
                v-if="radioSelector === 'EN'" />
        <el-input
                :size="size"
                v-model="locValue[localKey]"
                type="text"
                @input="updateInput()"
                v-else />

    </div>
</template>

<script>
export default {
    name: 'LocalizedInput',
    props: {
        value: Object,
        localKey: String,
        size: String
    },
    data: function() {
        return {
            locValue: {},
            radioSelector: []
        }
    },
    methods: {
        updateInput() {
            this.$emit('input', this.locValue)
        }
    },
    mounted() {
        this.locValue = this.value

        this.radioSelector = 'EN'
    },
    watch: {
        value: function(val) {
            this.locValue = val
        }
    }
}
</script>